export const ImportStatuses = {
  created: 'created',
  validating: 'validating',
  validated: 'validated',
  running: 'running',
  paused: 'paused',
  completed: 'completed',
  failed: 'failed',
  rollingBack: 'rolling_back',
  rolledBack: 'rolled_back'
};

export const ImportStatusLabels = {
  created: 'Created',
  validating: 'Validating',
  validated: 'Validated',
  running: 'Running',
  paused: 'Paused',
  completed: 'Completed',
  failed: 'Failed',
  rolling_back: 'Rolling back',
  rolled_back: 'Rolled back'
};

export const ImportStatusColors = {
  created: 'gray',
  validating: 'blue',
  validated: 'teal',
  running: 'blue',
  paused: 'orange',
  completed: 'green',
  failed: 'red',
  rolling_back: 'orange',
  rolled_back: 'purple'
};

/**
 * Statuses the API is still working through; the detail page polls while in one.
 */
export const ImportBusyStatuses = [ImportStatuses.validating, ImportStatuses.running, ImportStatuses.rollingBack];

/**
 * Statuses during which the manifest and files may still be (re)uploaded.
 */
export const ImportUploadableStatuses = [ImportStatuses.created, ImportStatuses.validated];

export const ImportRowStatuses = {
  pending: 'pending',
  valid: 'valid',
  warning: 'warning',
  error: 'error',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  skipped: 'skipped'
};

export const ImportRowStatusColors = {
  pending: 'gray',
  valid: 'green',
  warning: 'orange',
  error: 'red',
  processing: 'blue',
  completed: 'green',
  failed: 'red',
  skipped: 'gray'
};

/**
 * Row statuses whose overrides may still be edited; mirrors ImportRowStatuses::EDITABLE.
 */
export const ImportRowEditableStatuses = ['pending', 'valid', 'warning', 'error', 'failed', 'skipped'];

export const ImportSources = {
  local: 'local',
  dropbox: 'dropbox'
};

export const ImportFileTypes = ['coi', 'contract', 'attachment'];

export const ImportEntityStatuses = ['active', 'archived'];

/**
 * Dropbox staging states that are still in progress (summary.dropbox.status).
 */
export const DropboxBusyStatuses = ['queued', 'listing', 'staging'];

/**
 * A busy pull that has not written progress for this long is presumed dead
 * (the worker was restarted or timed out) and the UI says so.
 */
export const DropboxStaleSeconds = 10 * 60;

/**
 * Fill-in-the-blanks states that are still in progress (summary.classification.status).
 */
export const ClassificationBusyStatuses = ['queued', 'running'];

/**
 * What the fill-in-the-blanks pass may fill, in the order the API applies them.
 */
export const ImportFillTasks = [
  { value: 'file_type', label: 'File types', description: 'Label blank file types as COI, contract or attachment.' },
  { value: 'insured_email', label: 'Insured email', description: 'The producer email on the COI, or the insured\'s own address when a document shows one.' },
  { value: 'insured_contact', label: 'Insured contact details', description: 'Address, phone and cc email from the COI or contract.' },
  { value: 'record_contact', label: 'Record contact details', description: 'The record contact email and the contract number.' },
  { value: 'project_details', label: 'Project details', description: 'Project name, number, description and term, usually from the contract.' },
  {
    value: 'archive',
    label: 'Archive superseded files',
    description: 'Mark a file archived when a newer file of the same type exists for the record (policy dates, license expirations).'
  }
];
